import React from 'react';
import { Filter, TextInput, DateInput, BooleanInput } from 'react-admin';

const ExerciseFilters = props => (
  <Filter {...props}>
    <TextInput label="ID" source="id" />
    <TextInput label="Name" source="name" />
    <TextInput label="Coach" source="coach" />
    <DateInput label="Created At" source="created_at" />
    <BooleanInput label="Public" source="public" />
    <BooleanInput label="Enabled" source="enabled" />
    <BooleanInput label="Approved" source="approved" />
  </Filter>
);

export default ExerciseFilters;



// WEBPACK FOOTER //
// ./src/resources/exercises/ExerciseFilters.jsx